import { Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import { useOrganization } from '_/contexts/OrganizationContext';
import { useProject } from '_/contexts/ProjectContext';
import { useLoginPools } from '_/hooks/useLoginPools';
import React, { ReactElement } from 'react';

const LoginPoolsContainer = (): ReactElement => {
  const { selectedProject, selectedProjectSlug } = useProject();
  const { selectedOrgSlug } = useOrganization();
  const { isLoading } = useLoginPools(selectedProject?.id, selectedOrgSlug, selectedProjectSlug);

  return (
    <AsyncPageContainer isLoading={isLoading}>
      <Outlet />
    </AsyncPageContainer>
  );
};

export default LoginPoolsContainer;
